<template>
    <el-container>
        <el-header style="height: 50px;">
            <Header />
        </el-header>
        <el-container>
            <el-aside width="200px">
                <Sidebar />
            </el-aside>
            <el-main>
                <transition name="fade" mode="out-in">
                    <router-view />
                </transition>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import Header from './Header'
import Sidebar from './Sidebar'

export default {
    components: {
        Header,
        Sidebar
    },
    props: {},
    data() {
        return {}
    },
    watch: {},
    computed: {},
    mounted() {},
    methods: {}
}
</script>
<style lang="scss" scoped>
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #F5F5F5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background-color: #F5F5F5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #555;
}
.el-container {
    height: 100%;
}
.el-header {
    background-color: #fff;
    color: #333;
    @include border-bottom-1px;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    padding: 0;
    z-index: 2;
}
.el-aside {
    width: 200px;
    display: block;
    position: absolute;
    left: 0;
    top: 50px;
    bottom: 0;
    overflow-y: auto;
    border-right: solid 1px #e6e6e6;
    background-color: #283244;
}
.el-main {
    display: block;
    position: absolute;
    left: 200px;
    top: 50px;
    bottom: 0;
    right: 0;
    overflow-y: auto;
    background: #f1f4f9;
    padding: 0;
}
</style>